import React, { Component } from "react";
import { connect } from "react-redux";
import iconRight from "../../../assets/images/Icon-arrow-right.png";
import { AddSaleOrder, AvailableItems, fileUpload, fileDownload, UpdateSaleOrder, updateMultipleItems } from "../../../store/actions";
import { DayPicker } from "react-day-picker";
import Select from 'react-select';
import Loader from "../../../assets/images/loader.gif";
import { Buffer } from "buffer";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png';
import { capitalize } from "lodash";
import { addMonths, endOfMonth } from "date-fns";

class AddOrdersView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      availableItems: [],
      orderDate: new Date(),
      billingDate: new Date(),
      showOrderDatePicker: false,
      selectedItems: [],
      selectedCompany: {},
      saleId: "",
      totalPrice: 0,
      orderStatus: { value: "open", label: "Open" },
      orderStatusList: [{ value: "open", label: "Open" }, { value: "billed", label: "Billed" }],
      showBillingDatePicker: false,
      fileName: "",
      url: "",
      src: "",
      file: "",
      container: "pcpayadmin",
      mimetype: ""
    };
  };

  async componentDidMount() {
    let { isEdit, orderData } = this.props;
    await this.props.AvailableItems();
    let availableItems = this.props.AVAILABLE_ITEMS.map(el => {
      let { clockItem } = el;
      return { ...el, value: el._id, label: `${clockItem.itemName} - ${el.serialNumber}` }
    });
    if (isEdit) {
      let { billingDocument, orderDate, totalPrice, company, inventoryItems, billingDate, orderStatus, saleId } = orderData;

      if (billingDocument?.container && billingDocument?.fileName) {
        let file = await fileDownload(billingDocument.container, billingDocument.fileName, billingDocument.mimetype);

        this.setState({
          src: file,
          fileName: billingDocument.fileName
        })

      };
      let selectedCompany = { ...company, value: company._id, label: `${company.companyShortName} - ${company.companyName}` };
      this.setState({
        orderDate: new Date(orderDate),
        totalPrice,
        selectedCompany,
        clients: [selectedCompany],
        saleId,
        selectedItems: inventoryItems.map(it => ({ ...it, value: it._id, label: `${it.clockItem.itemName} - ${it.serialNumber}` })),
        billingDate: billingDate ? new Date(billingDate) : new Date(),
        orderStatus: { value: orderStatus, label: capitalize(orderStatus) }
      });
    } else {
      let clients = this.props.CompaniesReducer.filter(cl => ["Client", "Demo"].includes(cl.companyType) && !cl.locked).map(el => {
        return { ...el, value: el._id, label: `${el.companyShortName} - ${el.companyName}` };
      });
      this.genSaleId();
      this.setState({ clients });
    }
    this.setState({ availableItems });
  }

  genSaleId = () => {
    let sales = this.props.SALE_ORDERS?.length || 0;
    let saleNum = String(sales + 1).padStart(5, "0");
    this.setState({ saleId: `SO${saleNum}` });
  }
  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  onSelectFile = (e, isDrop) => {
    let file = isDrop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    let src;
    let fileNameArr = file.name.split(".");
    let fileExt = fileNameArr.pop();
    let fileName = `${fileNameArr.join("")}~${Date.now()}.${fileExt}`;
    reader.onload = (res) => {
      src = res.target.result;
      const i = src.indexOf("base64,");
      const buffer = Buffer.from(src.slice(i + 7), "base64");
      const _file = new File([buffer], fileName, {
        type: file.type
      });
      const fd = new FormData();
      fd.append("file", _file);
      fd.append("filename", _file.name);
      fd.append("container", this.state.container);
      fileUpload(fd).then(result => {
        this.setState({ url: result });
      });
      this.setState({
        fileError: null,
        file: _file,
        fileName,
        mimetype: file.type,
        src
      });
    };
  }


  AddUpdateOrder = async () => {
    let { selectedCompany, selectedItems, totalPrice, orderDate, billingDate, orderStatus, url, fileName, container, mimetype, saleId } = this.state;
    let inventoryItems = selectedItems.map(it => it._id);
    let payload = {
      company: selectedCompany._id,
      inventoryItems,
      totalPrice,
      saleId,
      orderDate: Number(orderDate),
      billingDate: Number(billingDate),
      orderStatus: orderStatus.value,
      createdBy: this.props.UserReducer.username
    };
    let serviceWarrantyEndDate = Number(endOfMonth(addMonths(orderDate, 6)));
    await this.props.updateMultipleItems("_id", inventoryItems, { company: selectedCompany._id, serviceWarrantyEndDate });
    if (orderStatus.value === 'billed') payload.billingDocument = {
      url,
      fileName,
      container,
      mimetype
    };
    if (this.props.isEdit) {
      let { _id } = this.props.orderData;
      payload._id = _id;
      await this.props.UpdateSaleOrder(payload);
    } else {
      await this.props.AddSaleOrder(payload);
    }
    this.props.closeSidebar();
  };

  render() {
    const { loading, availableItems, clients, selectedItems, selectedCompany, orderStatusList, totalPrice, orderDate, billingDate, orderStatus, saleId } = this.state;

    return (
      <>
        {loading ?
          <Loader></Loader> :
          <div className={`AddPurchaseOrders`}>
            <div className="overlay-pop" onClick={this.props.closeSidebar}></div>
            <div>
              <div className="userHeader d-flex align-items-center justify-content-between">
                <div className="UserName">
                  <h2>Add Outbound Orders Detail</h2>
                </div>
                <div className="iconRight" onClick={this.props.closeSidebar}>
                  <img src={iconRight} alt=""></img>
                </div>
              </div>
              <div className="item-body">
                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Order Date</span>
                  </div>
                  <div className="itemOutput date-range">
                    <input
                      type={"text"}
                      value={orderDate.toLocaleDateString()}
                      onClick={() => this.setState({ showOrderDatePicker: !this.state.showOrderDatePicker })}
                    />
                    {this.state.showOrderDatePicker && <DayPicker
                      mode='single'
                      selected={orderDate}
                      onDayClick={d => this.setState({ orderDate: d })}
                    />}
                  </div>
                </div>
                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Sale ID</span>
                  </div>
                  <div className="itemOutput">
                    <input
                      type="string"
                      value={saleId}
                      onChange={(e) =>
                        this.setState({ saleId: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Total Price</span>
                  </div>
                  <div className="itemOutput">
                    <input
                      type="number"
                      value={totalPrice}
                      onChange={(e) =>
                        this.setState({ totalPrice: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>

                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Client Name</span>
                  </div>
                  <div className="itemOutput auto-complete-box">
                    <Select
                      options={clients}
                      onChange={selected => this.setState({ selectedCompany: selected })}
                      value={selectedCompany}
                    />
                  </div>
                </div>
                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Item Name</span>
                  </div>
                  <div className="itemOutput">
                    <Select
                      options={availableItems}
                      placeholder={"Select Item(s)"}
                      isMulti={true}
                      onChange={selected => this.setState({ selectedItems: selected })}
                      value={selectedItems}
                    />
                  </div>
                </div>
                <div className="itemList d-flex align-items-center justify-content-between">
                  <div className="itemLabel">
                    <span>Order Status</span>
                  </div>
                  <div className="itemOutput text-start">
                    <Select
                      options={orderStatusList}
                      onChange={selected => this.setState({ orderStatus: selected })}
                      value={orderStatus}
                      defaultValue={orderStatus}
                    />
                  </div>
                </div>
                {
                  orderStatus.value === "billed" &&
                  <>
                    <div className="itemList d-flex align-items-center justify-content-between">
                      <div className="itemLabel">
                        <span>Billing Date</span>
                      </div>
                      <div className="itemOutput date-range">
                        <input
                          type={"text"}
                          value={billingDate.toLocaleDateString()}
                          onClick={() => this.setState({ showBillingDatePicker: !this.state.showBillingDatePicker })}
                        />
                        {this.state.showBillingDatePicker && <DayPicker
                          mode='single'
                          selected={billingDate}
                          onDayClick={d => this.setState({ billingDate: d })}
                        />}
                      </div>
                    </div>
                    <div className="itemList d-flex align-items-center justify-content-between">
                      <div className="itemLabel">
                        <span>Image</span>
                      </div>
                      <div
                        className="itemOutput_full file-area"
                        onDragOver={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <label
                          onDrop={(e) => {
                            this.setState({ dragging: false });
                            e.preventDefault();
                            this.onSelectFile(e, true);
                          }}
                          onDragOver={(e) => {
                            this.setState({ dragging: true });
                            e.preventDefault();
                          }}
                          onDragEnd={() => this.setState({ dragging: false })}
                          onDragLeave={() => this.setState({ dragging: false })}
                          htmlFor="upload_image"
                          className={`df acc upload_lbl ${this.state.fileName
                            ? "selected " : ""} ${this.state.dragging ? "dragging" : ""}`}
                        >
                          {!this.state.fileName && (
                            <label htmlFor="upload_image">
                              <img className="uploadIcon" src={uploadIcon} alt="" />
                              <span className="fwc fwsb5 fs16">Upload Billing Document</span>
                            </label>
                          )}

                          {this.state.fileName && (
                            <div className="upload_label">
                              <object className="thambsImage" data={this.state.src} alt={this.state.fileName} />
                            </div>
                          )}
                          <input
                            accept=".PNG,.png,.jpg, .JPEG, .pdf"
                            className="dn"
                            type="file"
                            id="upload_image"
                            onChange={this.onSelectFile}
                            ref={this.fileInput}
                          ></input>
                        </label>
                        {this.state.fileError && (
                          <p className="toast">
                            {this.state.fileError} please try again
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                }
              </div>
              <div className="item-footer text-end">
                <button className="pop_wth_btn" onClick={this.props.closeSidebar}>
                  Cancel
                </button>
                <button
                  className="save-btn"
                  onClick={this.AddUpdateOrder}
                  disabled={!selectedCompany._id || !selectedItems.length || (orderStatus.value === "billed" && !this.state.fileName)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>}
      </>
    );
  };
};

const mapStateToProps = ({ UserReducer, UsersReducer, InventoryItemsReducer, SaleOrdersReducer, CompaniesReducer }) => {
  let { AVAILABLE_ITEMS, SALE_ORDERS } = SaleOrdersReducer;
  return { UserReducer, UsersReducer, InventoryItemsReducer, AVAILABLE_ITEMS, CompaniesReducer, SALE_ORDERS }
};
export default connect(mapStateToProps, {
  AddSaleOrder,
  AvailableItems,
  UpdateSaleOrder,
  updateMultipleItems
})(AddOrdersView);
